import { PushNotifications } from '@capacitor/push-notifications';
import { fetchData } from '../api/api';

export async function requestMicrophonePermission() {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.getTracks().forEach(track => track.stop());
    return true;
  } catch (error) {
    console.warn('❌ Доступ к микрофону не получен:', error);
    return false;
  }
}

// Запрос на пуш-уведомления
export async function requestPushPermission(userId) {
  try {
    const result = await PushNotifications.requestPermissions();

    let status = 0; //'never_asked'
    if (result.receive === 'granted') {
      await PushNotifications.register();
      status = 1; //'granted'
    } else {
      status = 2; //'denied'
    }

    // Записываем результат на сервер
    await fetchData('/api/push-permission', 'POST', { userId, status });

    return status; // 👉 теперь можно использовать в userInfo
  } catch (error) {
    console.error('❌ Ошибка при запросе пушей:', error);
    return 0; // на всякий случай оставим как "never_asked"
  }
}
